import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';

import { env } from '~/commons/config';

import PageAnnouncements from '../../app/components/pages/PageAnnouncements.jsx';
import PageAnnouncement from '../../app/components/pages/PageAnnouncement.jsx';

const root = document.getElementById('announcements');

if (root) {
  ReactDOM.render(
    (
      <Router basename={env.base}>
        <Switch>
          <Route exact path="/announcements">
            <PageAnnouncements title="最新消息" path="home" />
          </Route>
          <Route path="/announcements/:_id">
            <PageAnnouncement />
          </Route>
        </Switch>
      </Router>
    ),
    root,
  );
}
